export default "data:image/svg+xml,es-cn.svg"